import React from "react";

class EmailMultiValueTextInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      isValid: false,
      emailError: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.addEmailValue = this.addEmailValue.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange(event) {
    const { value } = event.target;
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); 
    this.setState({
      email: value,
      isValid: isValid,
      emailError: null,
    });
  }
  handleBlur() {
    this.addEmailValue();
  }

  addEmailValue() {
    const { textFields, handleMultiTextField } = this.props;
    const { email, isValid } = this.state;
    if (email.trim() !== "") {
      if (isValid) {
        handleMultiTextField([...textFields, email.trim()]);
        this.setState({ email: '', isValid: false }); 
      } else {
        this.setState({
          emailError: (
            <small className="text-danger" style={{ marginLeft: "40px", display: "ruby" }}>Please Enter Correct Email</small>
          ),
        });
      }
    }
  }

  onRemove(removedIndex) {
    const { textFields, handleMultiTextField } = this.props;

    const withoutRemovedValue = textFields.filter(
      (_, index) => index !== removedIndex
    );
    handleMultiTextField(withoutRemovedValue);
  }
  render() {
    const { textFields } = this.props;
    const { email, emailError } = this.state;

    return (
      <div>
        <div className="input-container" style={{ position: 'relative', width: '540px' }}>
          <input
            onChange={this.handleChange}
            value={email}
            type="text"
            className="form-control"
            style={{ width: "500px", marginLeft: "40px" }}
            onKeyPress={(e) => {
              if (e.key === "Enter" ) {
                this.addEmailValue();
              }
            }}
            onBlur={this.handleBlur}
            id="exampleFormControlInput1"
            placeholder="Enter Your Email"
          />
          <i
            className="fa fa-plus icon"
            onClick={this.addEmailValue}
            style={{
               position: 'absolute',
               top: '50%',
               right: '0px',
               transform: 'translateY(-50%)',
               cursor: 'pointer',
               color: 'gray',
               fontSize: '20px',
               borderRadius: '5px',
               padding: '10px',
               boxSizing: 'border-box', 
               display: 'flex', 
               alignItems: 'center', 
               justifyContent: 'center',  
               width: '39px',  
               height: '38px',
               boxShadow: "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px", 
            }}
          ></i>
        </div>
        {emailError}
        <div
          style={{
            display: "flex", gap: "8px", maxWidth: "540px",
            width: "400%",
            flexWrap: "wrap",
          }}>
          {!textFields ? "" : textFields.map((item, index) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                position: "relative",
                gap: "5px",
                marginTop: "8px",
                left: "40px",
                display: "inline-block",
                borderRadius: "5px",
                border: "1px solid lightgray",
                padding: "5px 1px",
              }}
            >
              <span
                style={{
                  color: "#44444",
                  padding: "8px 0px 8px 16px",
                }}
                key={index}
              >
                {item}
              </span>
              <img
                onClick={() => this.onRemove(index)}
                style={{
                  padding: "3px",
                  background: "black",
                  cursor: "pointer",
                  width: "18px",
                  alignSelf: "flex-start",
                  borderRadius: "10px",
                  marginLeft: "8px",
                  marginRight: "2px"
                }}
                src="https://img.icons8.com/ios-glyphs/30/FFFFFF/delete-sign.png"
                alt="remove"
              /><br />
            </div>
          ))}
        </div>
      </div>
    );
  }
}
export default EmailMultiValueTextInput;